'use es6';

import EmailCapturePromptMessage from 'conversations-visitor-message-history/email-capture/EmailCapturePromptMessage';
import { connect } from 'react-redux';
import { getColoring } from '../../../selectors/widgetDataSelectors/getColoring';
import { shouldRequireConsentToCommunicate } from '../../../selectors/widgetDataSelectors/shouldRequireConsentToCommunicate';
import { getConsentToCommunicateMessage } from '../../../selectors/widgetDataSelectors/getConsentToCommunicateMessage';
import { getCompanyName } from '../../../selectors/widgetDataSelectors/getCompanyName';
import { getHasVisitorEmail } from '../../../selectors/widgetDataSelectors/getHasVisitorEmail';
import { sendVisitorEmailAddress } from '../../../email-capture/actions/VisitorEmailAddressActions';
import { getCurrentThreadId } from '../../selectors/getCurrentThreadId';
const mapStateToProps = state => ({
  coloring: getColoring(state),
  companyName: getCompanyName(state),
  consentToCommunicateMessage: getConsentToCommunicateMessage(state),
  hasVisitorEmail: getHasVisitorEmail(state),
  requiresConsentToCommunicate: shouldRequireConsentToCommunicate(state),
  threadId: getCurrentThreadId(state)
});
const mapDispatchToProps = {
  sendVisitorEmailAddress
};
export default connect(mapStateToProps, mapDispatchToProps)(EmailCapturePromptMessage);